import {ActionTree} from "vuex";
import {EventImplementationState, EventImplementation} from "./model";
import {RootStateType} from "@/store";
import {AxiosResponse} from "axios";

const actions: ActionTree<EventImplementationState, RootStateType> = {
  findList({rootGetters, commit}) {
    return rootGetters['hcs/client'].get('/event_implementations')
        .then((response: AxiosResponse) => {
          const eventImplementations: EventImplementation[] = response.data;
          commit('setEventImplementations', eventImplementations);
          return eventImplementations;
        });
  },
  create({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].post('/event_implementations', params)
        .then((response: AxiosResponse) => {
          const eventImplementation: EventImplementation = response.data;
          commit('addEventImplementation', eventImplementation);
          return eventImplementation;
        });
  },
  update({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].patch(`/event_implementations/${params.id}`, params)
        .then((response: AxiosResponse) => {
          const eventImplementation: EventImplementation = response.data;
          commit('updateEventImplementation', eventImplementation);
          return eventImplementation;
        });
  },
  delete({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].delete(`/event_implementations/${id}`)
        .then((response: AxiosResponse) => {
          commit('deleteEventImplementation', id);
        });
  }
}

export default actions;
